import React from 'react';
import { Icon } from '@chakra-ui/icons';
import { Color } from '../../theme/color';

export const ActionCancelIcon = ({ color = Color.ACTION }: { color?: string }) => {
	return (
		<Icon
			width="auto"
			height="10px"
			viewBox="0 0 9 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.25 1.25L0.75 8.75"
				stroke={color}
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M0.75 1.25L8.25 8.75"
				stroke={color}
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};
